export default {
  "content": "<title>lock</title><path d=\"M1 5H.995C.455 5 0 5.45 0 6.003v4.994A.992.992 0 00.995 12h8.01c.54 0 .995-.45.995-1.003V6.003A.992.992 0 009.005 5H9v-.998A4 4 0 005 0C2.795 0 1 1.792 1 4.002V5zm4-3c1.105 0 2 .977 2 2.183V5H3v-.817C3 2.977 3.898 2 5 2z\" fill=\"#FFF\" fill-rule=\"evenodd\"/>",
  "attrs": {
    "width": "10",
    "height": "12",
    "viewBox": "0 0 10 12",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};